import { useDispatch } from "react-redux"
import { showModal } from "../../../../../../redux/actions"
import { useLazySearchManufacturersQuery } from "../../../../../../redux/slices/catalogSlice"

const useCatalog = () => {
  const dispatch = useDispatch()

  const openManufacturerModal = (partnerListingId, app, revokeAccess) => {
    dispatch(showModal('MANUFACTURER_MODAL', {
      partnerListingId,
      selectedApp: { name: app.name, integrationType: app.type},
      isRevokeMode: revokeAccess,
    }))
  }

    const [searchManufacturers, searchManufacturersResults] = useLazySearchManufacturersQuery()

    const searchManufacturersByName = (term) => {
      if (term) searchManufacturers({ manufacturerName: term })
    }

    const searchManufacturersById = async (manufacturerId) => {
      try {
        const results = await searchManufacturers({ manufacturerId }).unwrap()
        return results?.length ? results[0] : null
      } catch (err) {
        console.error(err)
        return null
      }
    }

    const searchManufacturersByTerm = (term) => {
      if (!term) return
      const parsed = Number(term)
      if (Number.isInteger(parsed) && parsed > 0) {
        searchManufacturers({ manufacturerId: parsed })
      } else {
        searchManufacturers({ manufacturerName: term })
      }
    }

    return {
      openManufacturerModal,
      searchManufacturersByName,
      searchManufacturersById,
      searchManufacturersByTerm,
      searchManufacturersResults,
    }
  }
  
  export default useCatalog